import {scroller} from 'react-scroll';

export const scrollToContact = () => {
    scroller.scrollTo("contact-container", {
      duration: 600,
      delay: 0,
      smooth: "easeInOutQuart",
    });
};
